import React from 'react';
import classnames from 'classnames/bind';
import { NavLink, NavLinkProps } from 'react-router-dom';

import { IconType } from 'types/icon';
import { NavRoute } from 'application/types/routes';

import { Icon } from 'components/Icon/IconDeprecated';

import styles from './Nav.module.scss';

const c = classnames.bind(styles);

type PrimaryLinkProps = React.PropsWithChildren<
  Omit<NavLinkProps, 'to' | 'className'>
> & {
  route: NavRoute;
  icon: IconType;
  disabled?: boolean;
};

export function PrimaryLink({
  route,
  icon,
  disabled,
  children,
  ...props
}: PrimaryLinkProps) {
  if (disabled) {
    return (
      <li>
        <span className={c('primary-link', 'disabled')} aria-disabled="true">
          <Icon name={icon} />
          <span>{children}</span>
        </span>
      </li>
    );
  }

  return (
    <li>
      <NavLink
        {...props}
        className={({ isActive }) => c('primary-link', { selected: isActive })}
        to={route}
      >
        <Icon name={icon} />
        <span>{children}</span>
      </NavLink>
    </li>
  );
}
